import { useEffect, useState } from "react";
import { Label } from "./ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

// getMembersByGroup should be imported from your service
import { membershipService } from "../services/index"; // adjust path accordingly

const UserProfileSelect = ({
  profiles,
  groupId,
  onUserSelect,
  onProfileSelect,
}) => {
  const [filteredProfiles, setFilteredProfiles] = useState([]);

  useEffect(() => {
    const fetchGroupMembers = async () => {
      if (!groupId) return;

      const res = await membershipService.getMembersByGroup(groupId);
      if (res?.Data && Array.isArray(res.Data)) {
        const allowedProfileIds = res.Data.map((member) => member.profile?._id);
        const matchedProfiles = profiles.filter((profile) =>
          allowedProfileIds.includes(profile._id)
        );
        setFilteredProfiles(matchedProfiles);
      }
    };

    fetchGroupMembers();
  }, [groupId, profiles]);

  const handleProfileChange = (profileId) => {
    const selectedProfile = filteredProfiles.find(
      (profile) => profile._id === profileId
    );
    if (selectedProfile) {
      onProfileSelect(profileId); // profile ID
      onUserSelect(selectedProfile.entity._id); // user/entity ID
    }
  };

  return (
    <div>
      <Label className="text-left mt-4">Target User Profile: </Label>
      <Select onValueChange={handleProfileChange}>
        <SelectTrigger className="w-full p-2 mt-1 border border-gray-300 bg-white rounded focus:outline-none focus:border-b-2 focus:border-b-green-600">
          <SelectValue placeholder="-- Select Profile --" />
        </SelectTrigger>
        <SelectContent>
          {filteredProfiles.map((profile) => (
            <SelectItem key={profile._id} value={profile._id} className="py-2">
              {profile.name} ({profile.entity.email})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default UserProfileSelect;
